/**
 * ЧЕРНОВИКИ КОМПОЗЕРА ПО КОМНАТАМ/ТРЕДАМ (Антон, 2026-09-16 21:26 UTC).
 *
 * Постановка: начал писать в комнате, не отправил, переключился — при
 * возврате текст обязан быть на месте. Переживает перезагрузку страницы,
 * поэтому хранилище — localStorage, а не React-состояние.
 *
 * КЛЮЧ: `alg.draft.<roomId>` для композера комнаты и
 * `alg.draft.<roomId>.<threadId>` для композера треда (постановка прямо
 * предлагает такую схему). Префикс `alg.` — как у остальных наших ключей
 * (`alg.lang` в i18n/index.ts), чтобы черновики не пересекались с чужими.
 *
 * ГРАНИЦА МОДУЛЯ: только чтение/запись localStorage. Debounce и сброс
 * после отправки — в композерах: им виднее, когда текст считать черновиком,
 * а когда отправленным сообщением.
 *
 * Храним ТОЛЬКО текст. Подтверждённые упоминания (пилюли) и разметка
 * форматирования при восстановлении не воссоздаются: текст «@Имя»,
 * набранный вручную, и так был валидным состоянием композера — просто без
 * пилюли и без push. Это сознательное упрощение постановки («текст в
 * композере должен быть на месте»), а не потеря данных.
 */

/** Ключ localStorage для черновика композера. */
export function draftKey(roomId: string, threadId?: string): string {
  return threadId ? `alg.draft.${roomId}.${threadId}` : `alg.draft.${roomId}`;
}

/** Прочитать черновик. Пустая строка и отсутствие записи равнозначны. */
export function loadDraft(key: string): string {
  try {
    return localStorage.getItem(key) ?? "";
  } catch {
    // localStorage может быть недоступен (приватный режим, квота):
    // черновик тогда просто не восстановится, композер работает как раньше.
    return "";
  }
}

/**
 * Записать черновик. Пустой текст УДАЛЯЕТ запись, а не хранит пустую
 * строку: иначе после отправки сообщения в localStorage копился бы мусор
 * по одному ключу на каждую комнату, где человек когда-либо печатал.
 */
export function saveDraft(key: string, text: string): void {
  try {
    if (text) {
      localStorage.setItem(key, text);
    } else {
      localStorage.removeItem(key);
    }
  } catch {
    /* quota/приватный режим — молча живём без черновиков */
  }
}

/** Удалить черновик (после УСПЕШНОЙ отправки сообщения). */
export function clearDraft(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}
